import { render, staticRenderFns } from "./HomeFirstIdea.vue?vue&type=template&id=465db60c&scoped=true&"
import script from "./HomeFirstIdea.vue?vue&type=script&lang=ts&"
export * from "./HomeFirstIdea.vue?vue&type=script&lang=ts&"
import style0 from "./HomeFirstIdea.vue?vue&type=style&index=0&id=465db60c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "465db60c",
  null
  
)

export default component.exports